import React, { createContext, useContext, useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Button, CircularProgress } from '@mui/material';

const API = process.env.REACT_APP_API_URL || 'https://api.conectachurch.com.br';
const TenantContext = createContext(null);

export function useTenant() { return useContext(TenantContext); }

export function TenantProvider({ children }) {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slug) { setLoading(false); return; }
    fetch(`${API}/saas/igrejas/slug/${slug}`)
      .then(r => r.ok ? r.json() : null)
      .then(data => setTenant(data))
      .catch(() => setTenant(null))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}><CircularProgress /></Box>;

  if (slug && !tenant) {
    return (
      <Box sx={{ textAlign: 'center', py: 10 }}>
        <Typography variant="h4" sx={{ mb: 2 }}>Igreja não encontrada</Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>O endereço {slug} não corresponde a nenhuma igreja cadastrada.</Typography>
        <Button variant="contained" onClick={() => navigate('/')}>Voltar ao início</Button>
      </Box>
    );
  }

  return <TenantContext.Provider value={tenant}>{children}</TenantContext.Provider>;
}
